export default {
      id: "icon-carousel-arrow-usage",
      viewBox: "0 0 36 36",
      url: __webpack_public_path__ + "icons.svg#icon-carousel-arrow",
      toString: function () {
        return this.url;
      }
    }